<template>
  <div :class="['lr-modal', {'hide': !show}]">
    <div class="lr-box">
      <div class="lr-alert-msg" v-html="message"></div>
      <a class="button cta small right block" @click="show = false">
        Close
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'alert',
  computed: {
    alert () { return this.$store.state.global.alert },
    show: {
      get () { return this.alert.show },
      set (x) {
        this.$store.commit('global/setAlertData', {
          show: x,
          message: ''
        })
      }
    },
    message () { return this.alert.message }
  },
  methods: {
  },
  mounted () {
  },
}
</script>

<style lang="scss" scoped>
.lr-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.35);
  overflow: auto;
  opacity: 1;
  display: flex;
  justify-content: center!important;
  align-items: center!important;
  -webkit-transition: all 0.2s ease-in;
  -moz-transition: all 0.2s ease-in;
  -o-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;

  &.hide {
    top: -100%;
    opacity: 0;
  }
}
.lr-box {
  background: #fff;
  padding: 20px;
  border-radius: 6px;
  box-shadow: 3px 3px 2px rgba(0,0,0, .3);
  text-align: center;
  min-width: 300px;
  max-width: 500px;
}

.lr-alert-msg{
  margin-bottom: 20px;
  color: #45505b;
}
</style>



// WEBPACK FOOTER //
// src/components/App/Alert.vue